// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2QSVA","notes":"Notes_notes__1K-Do","note":"Notes_note__2E1HH","markdown":"Notes_markdown__3PWao"};